import React from 'react';
import './Copilot.scss';

interface CopilotMarkdownProps {
  content: string;
}

/**
 * Simple markdown renderer for agent responses.
 * Handles bold, headings, lists, and code blocks.
 *
 * TODO: Replace with react-markdown for proper rendering:
 * - Code blocks: content inside ``` is still transformed by other regexes
 * - Lists: <li> elements are not wrapped in <ul>
 * - dangerouslySetInnerHTML: react-markdown eliminates this entirely
 */
export function CopilotMarkdown({ content }: CopilotMarkdownProps) {
  // Escape HTML entities first to prevent XSS
  const escaped = content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  // Then apply markdown-to-HTML conversion
  const html = escaped
    // Code blocks
    .replace(/```(\w*)\n([\s\S]*?)```/g, '<pre><code>$2</code></pre>')
    // Inline code
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    // Bold
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    // Headings
    .replace(/^### (.+)$/gm, '<h4>$1</h4>')
    .replace(/^## (.+)$/gm, '<h3>$1</h3>')
    .replace(/^# (.+)$/gm, '<h2>$1</h2>')
    // Unordered lists
    .replace(/^- (.+)$/gm, '<li>$1</li>')
    // Paragraphs (double newline)
    .replace(/\n\n/g, '</p><p>')
    // Single newlines
    .replace(/\n/g, '<br/>');

  return <div className="copilot-markdown" dangerouslySetInnerHTML={{ __html: html }} />;
}
